import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import segmentsService from "../services/segmentsService";
import { Segment } from "../types/segment";

const Segments: React.FC = () => {
  const navigate = useNavigate();
  const [segments, setSegments] = useState<Segment[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSegments();
  }, []);

  const loadSegments = async () => {
    try {
      const data = await segmentsService.listSegments();
      setSegments(data);
    } catch (error) {
      console.error("Failed to load segments:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div style={{ padding: "20px" }}>Loading segments...</div>;
  }

  return (
    <div style={{ padding: "20px", maxWidth: "900px" }}>
      <div style={{
        padding: "10px 14px",
        marginBottom: "16px",
        backgroundColor: "#fef3c7",
        border: "1px solid #f59e0b",
        borderRadius: "6px",
        fontSize: "13px",
        color: "#92400e",
      }}>
        This feature is in beta. If you run into any issues, please let us know.
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h1 style={{ margin: 0 }}>Segments</h1>
        <button
          className="primary-button"
          onClick={() => navigate("/segments/new")}
          style={{
            padding: "8px 16px",
            backgroundColor: "#000",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Create Segment
        </button>
      </div>

      {segments.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            padding: "60px 20px",
            color: "#6b7280",
          }}
        >
          <p>No segments yet. Create your first segment to identify subscriber groups.</p>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {segments.map((segment) => (
            <div
              key={segment.id}
              onClick={() => navigate(`/segments/${segment.id}`)}
              style={{
                padding: "16px 20px",
                backgroundColor: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <span style={{ fontWeight: 600, fontSize: "16px" }}>
                    {segment.name}
                  </span>
                  <span style={{
                    padding: "2px 8px",
                    borderRadius: "10px",
                    fontSize: "11px",
                    fontWeight: 500,
                    backgroundColor: segment.segment_type === "static" ? "#dbeafe" : "#d1fae5",
                    color: segment.segment_type === "static" ? "#1e40af" : "#065f46",
                  }}>
                    {segment.segment_type === "static" ? "Static" : "Dynamic"}
                  </span>
                  {segment.is_default && (
                    <span style={{
                      padding: "2px 8px",
                      borderRadius: "10px",
                      fontSize: "11px",
                      fontWeight: 500,
                      backgroundColor: "#f3e8ff",
                      color: "#6b21a8",
                    }}>
                      Default
                    </span>
                  )}
                </div>
                <div style={{ color: "#6b7280", fontSize: "13px", marginTop: "4px" }}>
                  {segment.rules.conditions?.length || 0} condition
                  {(segment.rules.conditions?.length || 0) !== 1 ? "s" : ""}
                  {" "}&middot;{" "}
                  {segment.rules.match === "all" ? "Match all" : "Match any"}
                </div>
              </div>
              <span
                style={{
                  padding: "4px 12px",
                  borderRadius: "12px",
                  fontSize: "13px",
                  fontWeight: 500,
                  color: "#374151",
                  backgroundColor: "#f3f4f6",
                }}
              >
                {segment.subscriber_count?.toLocaleString() ?? "—"} subscribers
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Segments;
